/* The black top bar from the homepage, on every page (Sava 24 Oct: "keep it everywhere").
   Same messages, look and 3-second rotation as home.html. Pages that already have #topbar are left alone.
   Product pages rebuild their header, so a watcher puts the bar back whenever a new header appears. */
(function () {
  if (document.getElementById("topbar")) return;
  /* a cart of only pet items gets "Free proof", as the cart's own trust line (orchestrator 31 Oct) */
  const PET_CART = window.CF_PET_PAGE === true || /\/cart(\.html)?$/.test(location.pathname) && (() => { try { const L = JSON.parse(localStorage.getItem("cfCart") || "[]");
    return L.length && L.every(x => x.kind === "mini" ? (x.isPet || /^mini:pet\b/.test(x.key || "")) : /^pet-|^memorial$|^house$/.test(x.key || "")); } catch (e) { return false; } })();
  const SEA = window.cfActiveSeasons ? cfActiveSeasons().find(x => x.topbar) : null; /* season message from seasons.js */
  const MSG = [SEA ? cfFill(SEA, SEA.topbar) : null, '🎁 Gift box included', (PET_CART ? '✨ Free proof on Standard and Faster' : '✨ Free face proof on Standard and Faster'), '🌍 Worldwide shipping'].filter(Boolean);
  const css = document.createElement("style");
  css.textContent = `.topbar{position:relative;height:34px;overflow:hidden;background:#221C14;color:#FFF7EC;font-size:13px;font-weight:800}
.topbar span{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:6px;padding:0 12px;white-space:nowrap;opacity:0;transform:translateY(100%);transition:opacity .35s,transform .45s cubic-bezier(.2,.9,.3,1)}
.topbar span.on{opacity:1;transform:none}.topbar span.out{opacity:0;transform:translateY(-100%)}.topbar b{color:#F9D648}
@media (min-width:1024px){.topbar{font-size:13.5px}}
@media (prefers-reduced-motion:reduce){.topbar span{transition:none}}`;
  document.head.appendChild(css);
  let ti = 0;
  const bar = () => {
    const d = document.createElement("div");
    d.className = "topbar"; d.setAttribute("aria-live", "polite");
    d.innerHTML = MSG.map((m, i) => `<span${i === ti ? ' class="on"' : ""}>${m}</span>`).join("");
    return d;
  };
  const place = () => {
    const s = document.querySelector(".smart");
    if (s && !s.querySelector(".topbar")) s.insertBefore(bar(), s.firstChild);
  };
  place();
  new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
  setInterval(() => {
    const tb = [...document.querySelectorAll(".topbar span")];
    if (!tb.length) return;
    const n = MSG.length, cur = ti;
    tb.forEach((s, i) => { if (i % n === cur) { s.classList.remove("on"); s.classList.add("out"); setTimeout(() => s.classList.remove("out"), 500); } });
    ti = (ti + 1) % n;
    tb.forEach((s, i) => { if (i % n === ti) s.classList.add("on"); });
  }, 3000);
})();
